import React from 'react';
import '../styling/journey.css';
import line from '../asset/bg-j.svg';

const Journey = () => {
  return (
    <div className="journey-page">
      {/* Background layer - fixed and behind everything */}
      <div
        className="bg-line-fixed"
        aria-hidden="true"
        style={{ backgroundImage: `url(${line})` }}
      />

      <div className="journey-container">
        <article className="journey-block left">
          <div className="content">
            <h3>Painting</h3>
            <p>
              When I was a child I was intent on becoming a vet. We always had a
              family dog. That first calling changed in a sudden flash and then my
              yearning turned to baking. I remember scavenging in libraries for old
              recipe books, rushing home watching a lump of over-floured dough
              never rise. And then I became a painter or more accurately, a
              sculptor and painter in that order, creating larger than life
              geometrical structures from wood, painted in primary colours. Blame
              my secondary school art teacher – a dramatic featured woman who
              boldly told me I had an unusual talent – one that needed nurturing
              and yielding.
              <br  /><br  /> 
              I remember being shat on by a passing pigeon on my way up the
              steps of Wolverhampton Art College on my first morning – both
              nervous and excited, and then in the evenings leaving exhausted to
              the sound of Wolverhampton Wanderers. 
              I was lucky to have been taught by some wonderful artists: Colin
              Harrison, who sadly passed away in 2017 –the greatest draughtman I
              knew who taught me everything about the metaphorical and the
              structure of a piece of work and the sculptor Anish Kapoor who
              helped me look in new ways – how the most simple material can be
              made more complex and the significance of connecting to the
              natural world. I can quite honestly say that during those three years,
              I have never been happier.
              <br  /><br  /> 
              I spent ten years as a painter, had a wonderful studio in an old
              chocolate factory and was able to produce the work I had always
              wanted to with a network of supporters, galleries and co-artists
              around me.
              <br  /><br  /> 
              And then…
            </p>
          </div>
        </article>

        <article className="journey-block right">
          <div className="content">
            <h3>Teaching</h3>
            <p>
              I went into teaching.
              I’m not sure what triggered this off. Indeed, I had had a successful
              ten years in my studio. I was at the time also teaching drawing and
              painting to students and I honestly can’t remember the reasons for
              my decision to turn to English. Probably, to do with a number of
              influences: my old dad gave me his love of Shakespeare and poetry. I
              learned how language can change, evoke, explore past lives, create
              characters and places that move and make you think. With words I
              learned (and am still learning) to make sense of the world around us
              and how writers can make their own choice of language to describe
              both the physical and the emotional and how all of that makes us
              think about how we are all connected. 
              <br  /><br  /> 
              My career in the classroom spanned over thirty years. With it came a great thirst for reading – I
              literally gobbled up books – Hesse and Murakami come to mind,
              both <i>A Wild Sheep Chase</i> and <i>Norwegian Wood</i>, books I will always
              return to. I then I built my own teaching practice and still do a little
              bit of teaching but decided to bid farewell to so many talented
              students who in turn taught me about honest story-making.
              <br  /><br  /> 
              And then…
            </p>
          </div>
        </article>

        <article className="journey-block left">
          <div className="content">
            <h3>Writing</h3>
            <p>
              I became a writer.
              I remember as though only yesterday, when at eighteen, full of
              anticipation, surrounded by my future husband’s family waiting for
              dinner to be served, my future father in law, the great Welsh poet
              Dannie Abse and author, Joan Abse, a great Ruskin advocate facing
              me. So there was I just a happy-go-lucky teenager in love and
              knowing near to nothing about poetry and only a little about Ruskin.
              <br  /><br  /> 
              How ignorant I felt when Dannie passed me one of his poems –
              steeped in Greek mythology and asked me what I thought. I could
              feel my face burning up. What do I say, embarrassed as though I was
              definitely about to fail this ‘test’. Somehow, I diverted the
              conversation, twisted it into some feeble explanation about the craft
              of drawing a line, something I’d once read – how the poetic voice is
              akin to a drawn line that doesn’t leave the page – it flows, ebbs,
              circles in all directions. And that seemed to work! What I did learn
              about writers though is that they are humble giving types.
            </p>
          </div>
        </article>
      </div>
    </div>
  );
};

export default Journey;
